module.exports = __webpack_public_path__ + "static/media/Lotto12.536600d0.jpg";